import pathfinder from '@fiverr-private/pathfinder';
import { OWNER_TYPES } from '../utils/constants';
import axios from './axiosInstance';

const createCollection = async(name, resource) => {
    const { data } = await axios.post(pathfinder('create_collection'), {
        name,
        owner_type: OWNER_TYPES.USER,
        items: [
            {
                resource_id: resource.id,
                resource_type: resource.type
            }
        ]
    });

    return data;
};

const createCollectionItem = async(id, resource) => {
    const { data } = await axios.post(pathfinder('create_collection_item', { id }), {
        resource_id: resource.id,
        resource_type: resource.type
    });

    return data;
};

const deleteCollectionsItems = async(itemIds) => {
    const { data } = await axios.delete(pathfinder('delete_collections_items'), {
        data: {
            item_ids: itemIds
        }
    });

    return data;
};

const getCollections = async() => {
    const { data } = await axios.get(pathfinder('collection_list'));

    return data;
};

const api = {
    createCollection,
    createCollectionItem,
    deleteCollectionsItems,
    getCollections
};

export default api;
